import { DefaultProps } from '../../../types/DefaultProps';

import styles from './Category.module.scss';

import type { FC } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

type CategoryProps = {
  color: 'primary' | 'green' | 'orange' | 'blue';
  text: string;
};

// CategoryMid Styled
const CategoryMid: FC<CategoryProps> = ({ color, text }) => {
  switch (color) {
    case 'primary':
      return <i className={styles['mid-category']}>{text}</i>;
    case 'green':
      return <i className={styles['mid-category-green']}>{text}</i>;
    case 'blue':
      return <i className={styles['mid-category-blue']}>{text}</i>;
    case 'orange':
      return <i className={styles['mid-category-orange']}>{text}</i>;
    default:
      return assertNever(color);
  }
};

// CategoryMin Styled
const CategoryMin: FC<CategoryProps> = ({ color, text }) => {
  switch (color) {
    case 'primary':
      return <i className={styles['mid-category']}>{text}</i>;
    case 'green':
      return <i className={styles['mid-category-green']}>{text}</i>;
    case 'blue':
      return <i className={styles['mid-category-blue']}>{text}</i>;
    case 'orange':
      return <i className={styles['mid-category-orange']}>{text}</i>;
    default:
      return assertNever(color);
  }
};

export type ButtonProps = DefaultProps & {
  size: 'M' | 'S';
  color: 'primary' | 'green' | 'orange' | 'blue';
  text: string;
};

export const Category: FC<ButtonProps> = ({ text, size, color }) => {
  switch (size) {
    case 'M':
      return <CategoryMid text={text} color={color} />;
    case 'S':
      return <CategoryMin text={text} color={color} />;
    default:
      return assertNever(size);
  }
};
